import React from 'react';
import HeroSection from '../components/HeroSection';
import BenefitsSection from '../components/BenefitsSection';
import JobListings from '../components/JobListings';
import WhyWorkWithUs from '../components/WhyWorkWithUs';
import ApplicationProcess from '../components/ApplicationProcess';

const HomePage = () => {
  return (
    <main>
      <HeroSection />
      <WhyWorkWithUs />
      <BenefitsSection />
      <JobListings />
      <ApplicationProcess />
    </main>
  );
};

export default HomePage;